/**
 * @generated SignedSource<<19ac2dfe871323d1952d467f18dfdbc6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentAbility",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flightId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "strokes",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPairs",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Organisation",
  "kind": "LinkedField",
  "name": "organisation",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shotgun",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startingHole",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calculatedScores",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finishedHoles",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "score",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nationality",
  "storageKey": null
},
v22 = [
  (v19/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/),
  (v4/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v24 = [
  (v14/*: any*/),
  (v4/*: any*/)
],
v25 = [
  (v19/*: any*/),
  (v20/*: any*/),
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AutoScrollContainerQuery",
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Tournament",
        "kind": "LinkedField",
        "name": "tournament",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AutoScroll_tournament"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AutoScrollContainerQuery",
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Tournament",
        "kind": "LinkedField",
        "name": "tournament",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tournamentPlayersCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activeRound",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TournamentRound",
            "kind": "LinkedField",
            "name": "activeTournamentRound",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "round",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "scoreTemplate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FlightScore",
                "kind": "LinkedField",
                "name": "rankedFlightScores",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v4/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Flight",
                    "kind": "LinkedField",
                    "name": "flight",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TournamentRound",
                        "kind": "LinkedField",
                        "name": "tournamentRound",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Tournament",
                            "kind": "LinkedField",
                            "name": "tournament",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  (v3/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Pair",
                    "kind": "LinkedField",
                    "name": "pair",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Player",
                        "kind": "LinkedField",
                        "name": "playerA",
                        "plural": false,
                        "selections": (v22/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Player",
                        "kind": "LinkedField",
                        "name": "playerB",
                        "plural": false,
                        "selections": (v22/*: any*/),
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TournamentPlayer",
                    "kind": "LinkedField",
                    "name": "tournamentPlayer",
                    "plural": false,
                    "selections": [
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tournamentId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Player",
                        "kind": "LinkedField",
                        "name": "player",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          (v3/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tournamentRoundsCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "rankedEntries",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FlightScore",
                    "kind": "LinkedField",
                    "name": "activeFlightScore",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FlightScore",
                    "kind": "LinkedField",
                    "name": "flightScores",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "aggregatePosition",
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "aggregateCategoryPosition",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "aggregateScore",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "aggregateStrokes",
                        "storageKey": null
                      },
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Flight",
                        "kind": "LinkedField",
                        "name": "flight",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TournamentRound",
                            "kind": "LinkedField",
                            "name": "tournamentRound",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Tournament",
                                "kind": "LinkedField",
                                "name": "tournament",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Pair",
                        "kind": "LinkedField",
                        "name": "pair",
                        "plural": false,
                        "selections": (v24/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TournamentPlayer",
                        "kind": "LinkedField",
                        "name": "tournamentPlayer",
                        "plural": false,
                        "selections": (v24/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "FlightScoresInterface",
                "abstractKey": "__isFlightScoresInterface"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "categoryPosition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Player",
                    "kind": "LinkedField",
                    "name": "player",
                    "plural": false,
                    "selections": (v25/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "TournamentPlayer",
                "abstractKey": null
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isRankedEntry"
              },
              (v21/*: any*/),
              (v18/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Player",
                    "kind": "LinkedField",
                    "name": "playerA",
                    "plural": false,
                    "selections": (v25/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Player",
                    "kind": "LinkedField",
                    "name": "playerB",
                    "plural": false,
                    "selections": (v25/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "Pair",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v12/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fd88bdd0262d80aeeae9ee6fc50cbf25",
    "id": null,
    "metadata": {},
    "name": "AutoScrollContainerQuery",
    "operationKind": "query",
    "text": "query AutoScrollContainerQuery(\n  $id: ID!\n) {\n  currentAbility\n  tournament(id: $id) {\n    ...AutoScroll_tournament\n    id\n  }\n}\n\nfragment AutoScroll_tournament on Tournament {\n  tournamentPlayersCount\n  activeRound\n  databaseId\n  activeTournamentRound {\n    ...HoleByHoleTable_tournamentRound\n    id\n  }\n  ...HoleByHoleTable_tournament\n  id\n}\n\nfragment HoleByHoleRoundScore_flightScore on FlightScore {\n  finishedHoles\n  score\n  flight {\n    startDate\n    startingHole\n    tournamentRound {\n      shotgun\n      status\n      tournament {\n        organisation {\n          color\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  pair {\n    status\n    id\n  }\n  tournamentPlayer {\n    status\n    id\n  }\n}\n\nfragment HoleByHoleTableEntry_flightScore on FlightScore {\n  calculatedScores\n  databaseId\n  finishedHoles\n  position\n  score\n  flight {\n    tournamentRound {\n      tournament {\n        hasPairs\n        organisation {\n          color\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  pair {\n    playerA {\n      firstName\n      lastName\n      nationality\n      id\n    }\n    playerB {\n      firstName\n      lastName\n      nationality\n      id\n    }\n    id\n  }\n  tournamentPlayer {\n    category\n    tournamentId\n    player {\n      category\n      databaseId\n      firstName\n      lastName\n      nationality\n      id\n    }\n    id\n  }\n  ...HoleByHoleRoundScore_flightScore\n}\n\nfragment HoleByHoleTableOverallEntry_rankedEntry_3zCxOT on RankedEntry {\n  __isRankedEntry: __typename\n  __typename\n  id\n  nationality\n  position\n  score\n  strokes\n  ... on FlightScoresInterface {\n    __isFlightScoresInterface: __typename\n    flightScores {\n      __typename\n      aggregateCategoryPosition\n      aggregatePosition\n      aggregateScore\n      aggregateStrokes\n      calculatedScores\n      id\n      ...HoleByHoleRoundScore_flightScore\n    }\n  }\n  ... on Pair {\n    playerA {\n      firstName\n      lastName\n      id\n    }\n    playerB {\n      firstName\n      lastName\n      id\n    }\n  }\n  ... on TournamentPlayer {\n    category\n    categoryPosition\n    player {\n      firstName\n      lastName\n      id\n    }\n  }\n}\n\nfragment HoleByHoleTableOverallEntry_tournament on Tournament {\n  databaseId\n  hasPairs\n  tournamentRoundsCount\n  organisation {\n    color\n    id\n  }\n}\n\nfragment HoleByHoleTable_tournament on Tournament {\n  hasPairs\n  tournamentRoundsCount\n  rankedEntries {\n    __typename\n    id\n    name\n    position\n    strokes\n    ... on FlightScoresInterface {\n      __isFlightScoresInterface: __typename\n      activeFlightScore {\n        flightId\n        id\n      }\n      flightScores {\n        aggregatePosition\n        id\n      }\n    }\n    ... on TournamentPlayer {\n      category\n      categoryPosition\n    }\n    ...HoleByHoleTableOverallEntry_rankedEntry_3zCxOT\n  }\n  ...HoleByHoleTableOverallEntry_tournament\n}\n\nfragment HoleByHoleTable_tournamentRound on TournamentRound {\n  id\n  round\n  scoreTemplate\n  rankedFlightScores {\n    __typename\n    flightId\n    id\n    name\n    position\n    strokes\n    flight {\n      startDate\n      id\n    }\n    ...HoleByHoleTableEntry_flightScore\n  }\n}\n"
  }
};
})();

node.hash = "b3431749ccdce620406388038e732c0b";

module.exports = node;
